var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.137207,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F16941"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0985 20.9591L38.3672 20.9121C39.1201 20.9092 39.7281 21.5171 39.7252 22.27L39.6781 34.5388C39.6752 35.2916 39.0626 35.9043 38.3097 35.9072C37.5568 35.9101 36.9488 35.3021 36.9517 34.5492L36.9862 25.5715L21.905 40.6526L19.9846 38.7322L35.0657 23.6511L26.088 23.6855C25.3351 23.6884 24.7272 23.0804 24.73 22.3275C24.7329 21.5747 25.3456 20.962 26.0985 20.9591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeArrow);
export default __webpack_public_path__ + "static/media/orange-arrow.1325afec565fd5f06161ea00c379ccc2.svg";
export { ForwardRef as ReactComponent };